export default {
    indexTermSignatures:        { method: 'get',    url: 'term_signatures' },
    createTermSignature:        { method: 'post',   url: 'term_signatures'},
    updateTermSignature:        { method: 'put',    url: 'term_signatures/{id}'},
    destroyTermSignature:       { method: 'delete', url: 'term_signatures/{id}'},
    indexTermSignatureStatus:   { method: 'get',    url: 'term_signatures/status' },
    showTermSignature:          { method: 'get',    url: 'term_signatures/{id}/show' },
    termSignatureGenerate:      { method: 'post',   url: 'term_signatures/generate' },
}